import { useSignal } from '@preact/signals';
import { useCallback, useEffect } from 'preact/hooks';
import { SDN } from 'utils/constants.ts';
import { cn } from 'utils/cn.tsx';
import type { OfferImage as OfferImageType } from 'service/image/model.ts';
import { Icon } from 'components/atoms/Icon.tsx';

interface Props {
	alt?: string;
	className?: string;
	images?: undefined | OfferImageType[];
	imgClassName?: string;
	lazy?: boolean;
}

export function OfferImage({ images, imgClassName, className, alt, lazy = true }: Props) {
	const hasImageError = useSignal(false);
	const { url = '', src = '' } = images?.[0] ?? {};
	const hasImage = (url || src) && !hasImageError.value;
	const imgSrc = src || (url ? url + SDN.w280WebP : '');

	const onError = useCallback(() => {
		hasImageError.value = true;
	}, []);

	useEffect(() => {
		hasImageError.value = false;
		const img = new Image();
		img.onerror = onError;
		img.src = imgSrc;
	}, [imgSrc]);

	if (!hasImage)
		return (
			<Icon
				className={cn('position-absolute text-dark-blue-25', className)}
				fill
				size={64}
				type="no_photography"
			/>
		);

	return (
		<img alt={alt} className={cn('w-full h-full', imgClassName)} loading={lazy ? 'lazy' : 'eager'} src={imgSrc} />
	);
}
